<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import i18n from '../../../i18n';

export default {
  name: 'SkiRentalPrices',
  data() {
    return {
      showOldPeriodPrices: false,
      priceItemIndex: null,
    };
  },
  computed: {
    ...mapGetters({
      levels: 'skirental/getLevels',
      skiPackages: 'skirental/getPackages',
      skiTypes: 'skirental/getSkiTypes',
      personCategories: 'skirental/getPersonCategoriesWithAllOption',
      possiblePriceCombinations: 'skirental/getPossiblePriceCombinations',
      possiblePriceCombinationsWithPrices: 'skirental/getPossibleCombinationsWithPrices',
    }),
    ...mapState({
      season: state => state.skirental.season,
      prices: state => state.skirental.season.prices.items,
      pricesLoading: state => state.skirental.season.prices.itemsLoading,
      pricesError: state => state.skirental.season.prices.itemsError,
      pricesSaveLoading: state => state.skirental.season.prices.saveLoading,
      pricesSaveError: state => state.skirental.season.prices.saveError,
      personCategoriesLoading: state => state.skirental.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skirental.season.personCategories.itemsError,
      selectedNumberOfDays: state => state.skirental.season.priceCombinations.selectedNumberOfDays,
      selectedPersonCategoryIds: state =>
        state.skirental.season.priceCombinations.selectedPersonCategoryIds,
      selectedLevelIds: state => state.skirental.season.priceCombinations.selectedLevelIds,
      selectedSkiTypeIds: state => state.skirental.season.priceCombinations.selectedSkiTypeIds,
      selectedPackageIds: state => state.skirental.season.priceCombinations.selectedPackageIds,
      onlyShowSavedPrices: state => state.skirental.season.priceCombinations.onlyShowSavedPrices,
      priceCombinationsLoading: state => state.skirental.season.priceCombinations.itemsLoading,
      priceCombinationsError: state => state.skirental.season.priceCombinations.itemsError,
      levelsLoading: state => state.skirental.levels.itemsLoading,
      levelsError: state => state.skirental.levels.itemsError,
      packagesSaveError: state => state.skirental.packages.saveError,
      packagesLoading: state => state.skirental.packages.itemsLoading,
      packagesError: state => state.skirental.packages.itemsError,
      skiTypesSaveError: state => state.skirental.skiTypes.saveError,
      skiTypesLoading: state => state.skirental.skiTypes.itemsLoading,
      skiTypesError: state => state.skirental.skiTypes.itemsError,
    }),
    availableDays() {
      return [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14];
    },
    errorOccurred() {
      return this.pricesSaveError || this.pricesError;
    },
  },
  methods: {
    ...mapActions({
      loadLevels: 'skirental/levelsLoad',
      loadPackages: 'skirental/packagesLoad',
      loadSkiTypes: 'skirental/skiTypesLoad',
      loadPersonCategories: 'skirental/personCategoriesByIdLoad',
      loadPossiblePriceCombinations: 'skirental/possiblePriceCombinationsBySeasonIdLoad',
      loadPricesWithDaysBySeasonId: 'skirental/pricesWithDaysBySeasonIdLoad',
      setPriceCombinationNumberOfDays: 'skirental/setPriceCombinationNumberOfDays',
      setPriceCombinationPersonCategory: 'skirental/setPriceCombinationPersonCategory',
      setPriceCombinationLevel: 'skirental/setPriceCombinationLevel',
      setPriceCombinationPackage: 'skirental/setPriceCombinationPackage',
      setPriceCombinationSkiType: 'skirental/setPriceCombinationSkiType',
      setPriceCombinationOnlyShowSavedPrices: 'skirental/setPriceCombinationOnlyShowSavedPrices',
      setPrice: 'skirental/setPrice',
      setPriceDay: 'skirental/setPriceDay',
      priceCreate: 'skirental/priceCreate',
      priceSave: 'skirental/priceSave',
      priceRemove: 'skirental/priceRemove',
      setFiltersClear: 'skirental/setFiltersClear',
    }),
    createOrUpdatePrice(price, index) {
      this.priceItemIndex = index;

      const priceWithDays = Object.assign({}, price);
      priceWithDays.priceDays = priceWithDays.days;
      if (priceWithDays.id) {
        this.priceSave({
          seasonId: this.season.id,
          priceWithDays,
        });
      } else {
        this.priceCreate({
          seasonId: this.season.id,
          priceWithDays,
        });
      }
    },
    removePriceWithDays(priceId) {
      // eslint-disable-next-line no-alert
      if (!priceId || confirm(i18n.t('ski.skiPrice.removeAreYouSure'))) {
        this.priceRemove({
          seasonId: this.season.id,
          priceId,
        });
      }
    },
    onNumberOfDaysChange(days) {
      this.setPriceCombinationNumberOfDays(days);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onPersonCategoryChange(personCategoryIds) {
      this.setPriceCombinationPersonCategory(personCategoryIds);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onSkiLevelChange(skiLevelIds) {
      this.setPriceCombinationLevel(skiLevelIds);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onSkiPackageChange(skiPackageIds) {
      this.setPriceCombinationPackage(skiPackageIds);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onSkiTypeChange(skiTypeIds) {
      this.setPriceCombinationSkiType(skiTypeIds);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onShowOnlySavedPricesChange(onlyShowSavedPrices) {
      this.setPriceCombinationOnlyShowSavedPrices(onlyShowSavedPrices);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    onPriceChange(params, price) {
      this.setPrice({
        params,
        price,
      });
    },
    onPriceDayChange(priceAmount, priceDay, priceCombination) {
      this.setPriceDay({
        priceDay,
        priceAmount,
        price: priceCombination.price,
      });
    },
    doRefresh() {
      this.loadLevels();
      this.loadPackages();
      this.loadSkiTypes();
      this.loadPersonCategories(this.season.id);
      this.loadPricesWithDaysBySeasonId(this.season.id);
      this.loadPossiblePriceCombinations(this.season.id);
    },
    getCommissionOrContributionHeader() {
      const headerText = this.season.netOrGross === 'net'
        ? i18n.t('ski.skiPrice.dataHeaders.contribution')
        : i18n.t('ski.skiPrice.dataHeaders.commission');
      const ratioPercentage = this.season.netOrGross === 'net'
        ? this.season.contributionRatio
        : this.season.commissionRatio;

      return headerText.concat(': ').concat(ratioPercentage).concat('%');
    },
    scrollToLastPrice() {
      setTimeout(() => {
        const targetElement = this.$refs['ski-price-combination'][this.priceItemIndex];
        if (targetElement) {
          this.$vuetify.goTo(
            targetElement,
            {
              duration: 1500,
              offset: 0,
              easing: 'easeInOutCubic',
            },
          );

          this.priceItemIndex = null;
        }
      }, 3000);
    },
  },
  watch: {
    pricesLoading(newValue) {
      if (!newValue && this.priceItemIndex) {
        this.scrollToLastPrice();
      }
    },
  },
  mounted() {
    if (!this.levels || !this.levels.length) {
      this.loadLevels();
    }
    if (!this.skiPackages || !this.skiPackages.length) {
      this.loadPackages();
    }
    if (!this.skiTypes || !this.skiTypes.length) {
      this.loadSkiTypes();
    }
    if (this.season.id) {
      if (!this.priceCombinations || !this.priceCombinations.length) {
        this.loadPossiblePriceCombinations(this.season.id);
      }
      if (!this.personCategories || !this.personCategories.length) {
        this.loadPersonCategories(this.season.id);
      }
      if (!this.prices || !this.prices.length) {
        this.loadPricesWithDaysBySeasonId(this.season.id);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <h2 class="pb-3 d-inline-block">
      {{ $t('skiRental.dataHeaders.prices') }}
    </h2>
    <v-btn
      @click="doRefresh()"
      :loading="pricesLoading || priceCombinationsLoading"
      icon
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <v-card
      v-if="personCategories.length"
      class="pa-3 mx-auto"
      outlined
    >
      <v-layout>
        <v-flex class="font-weight-bold" sm12 xs12>
          <h3>
            {{ getCommissionOrContributionHeader() }}
          </h3>
          <h3>
            {{ $t('ski.supplier-currency') }}:
            <template v-if="season.supplier">
              {{ season.supplier.currency }}
              ({{ season.supplier.name }})
            </template>
          </h3>
        </v-flex>
      </v-layout>
      <v-layout class="pt-3">
        <v-flex class="font-weight-bold" sm1 xs1>
          <h3>{{ $t('ski.skiPrice.days') }}</h3>
        </v-flex>
        <v-flex sm12 xs12>
          <v-select
            @change="onNumberOfDaysChange($event)"
            :value="selectedNumberOfDays"
            :items="availableDays"
            :loading="pricesLoading || priceCombinationsLoading"
            :deletable-chips="true"
            :label="'Select multiple number of days'"
            item-text="name"
            item-value="id"
            chips
            multiple
          />
        </v-flex>
      </v-layout>
      <v-layout class="pt-3">
        <v-flex class="font-weight-bold" sm1 xs1>
          <h3>{{ $t('ski.skiPrice.filter') }}</h3>
        </v-flex>
        <v-flex sm3 xs3>
          <v-select
            @change="onPersonCategoryChange($event)"
            :value="selectedPersonCategoryIds"
            :items="personCategories"
            :loading="personCategoriesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Person categories'"
            item-text="nameWithAges"
            item-value="id"
            hide-details
            chips
            multiple
          />
        </v-flex>
        <v-flex sm2 xs2 offset-sm1>
          <v-select
            @change="onSkiTypeChange($event)"
            :value="selectedSkiTypeIds"
            :items="skiTypes"
            :loading="skiTypesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Ski types'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
          />
        </v-flex>
        <v-flex sm3 xs2 offset-sm1>
          <v-select
            @change="onSkiPackageChange($event)"
            :value="selectedPackageIds"
            :items="skiPackages"
            :loading="packagesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Ski packages'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
          />
        </v-flex>
        <v-flex sm2 xs2 offset-sm1>
          <v-select
            @change="onSkiLevelChange($event)"
            :value="selectedLevelIds"
            :items="levels"
            :loading="levelsLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Levels'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
          />
        </v-flex>
      </v-layout>
      <v-layout class="pt-2">
        <v-flex sm4 xs4 offset-sm1>
          <v-switch
            @change="onShowOnlySavedPricesChange($event)"
            :disabled="prices.length === 0"
            :label="$t('ski.skiPrice.onlyShowSavedPrices')"
            :input-value="onlyShowSavedPrices"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex
          v-if="!pricesLoading && !priceCombinationsLoading"
          class="font-weight-bold"
          sm12
          xs12
          offset-sm1
        >
          {{
            $t('ski.skiPrice.showingTotalPriceCombinations',
              { totalPrices: possiblePriceCombinationsWithPrices.length }
            )
          }}
          <template v-if="Object.keys(prices).length > 0">
            {{ $t('ski.skiPrice.pricesSavedOverall', { totalPrices: prices.length }) }}
          </template>
          <v-btn
            v-if="!pricesLoading && !priceCombinationsLoading"
            @click="setFiltersClear"
            class="mb-2"
            color="warning"
            small
            outline
          >
            {{ $t('ski.skiPriceSettings.clear-filters') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <span v-else>
      <v-btn
        v-if="!pricesLoading && !priceCombinationsLoading"
        :to="`/ski/rental/season/${season.id}/person-categories`"
        class="mb-2"
        color="warning"
        small
        outline
      >
        {{ $t('ski.skiPersonCategories.addMissingPersonCategories') }}
      </v-btn>
    </span>
    <v-alert
      :value="errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <v-container
      v-for="(priceCombination, index) in possiblePriceCombinationsWithPrices"
      :key="'ski-price-combination-' + index"
      :loading="pricesSaveLoading || priceCombinationsLoading"
      ref="ski-price-combination"
      grid-list-md
      text-xs-center
      xs12
    >
      <v-layout class="pt-3 font-weight-bold" row wrap>
        <v-flex sm2 xs2>
          <v-text-field
            @input="onPriceChange({ externalName: $event }, priceCombination.price)"
            :value="priceCombination.price ? priceCombination.price.externalName : undefined"
            :label="$t('ski.skiPrice.supplierText')"
            :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
            type="text"
          />
        </v-flex>
        <v-flex sm2 xs2>
          <v-text-field
            @input="onPriceChange({ name: $event }, priceCombination.price)"
            :value="priceCombination.price ? priceCombination.price.name : undefined"
            :label="$t('ski.skiPrice.customerText')"
            :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
            type="text"
          />
        </v-flex>
        <v-flex sm2 xs2>
          {{
            $t('ski.skiPrice.personCategoryNameWithAge',
              {
                name: priceCombination.personCategory.name,
                ageFrom: priceCombination.personCategory.ageFrom,
                ageTo: priceCombination.personCategory.ageTo
              }
            )
          }}
        </v-flex>
        <v-flex sm2 xs2>
          {{ priceCombination.skiType.name }}
        </v-flex>
        <v-flex sm2 xs2>
          {{ priceCombination.package.name }}
        </v-flex>
        <v-flex sm2 xs2>
          {{ priceCombination.level.name }}
        </v-flex>
      </v-layout>
      <v-layout class="pb-2" row>
        <v-flex
          v-for="(priceDay, index) in priceCombination.days"
          :key="'ski-price-combination-day-' + index"
        >
          <v-text-field
            @input="onPriceDayChange($event, priceDay, priceCombination)"
            :value="priceDay.price"
            :label="$t('ski.skiPrice.numDays', { numDays: priceDay.days })"
            :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
            type="Number"
            min="0"
          />
        </v-flex>
        <v-flex>
          <v-btn
            @click="createOrUpdatePrice(priceCombination.price, index)"
            :disabled="
              !priceCombination.price.name
              || !priceCombination.price.externalName
              || pricesSaveLoading
              || pricesLoading
              || priceCombinationsLoading
            "
            class="mb-1"
            color="green"
            small
            outline
          >
            {{ priceCombination.price.id ? $t('buttons.save') : $t('buttons.create') }}
          </v-btn>
          <v-btn
            @click="removePriceWithDays(priceCombination.price.id)"
            :disabled="!priceCombination.price.id
              || pricesSaveLoading
              || pricesLoading
              || priceCombinationsLoading
            "
            class="mb-1"
            color="error"
            small
            outline
          >
            {{ $t('buttons.remove') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </v-container>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/rental/SkiRentalSeasonPrices.vue